import { Component, Inject } from '@angular/core';

import {
  MODAL_OVERLAY_DATA,
  ModalOverlayRef,
  ModalOverlayServiceCloseEventType,
} from '@shared/components/modal-overlay';

import { MingaManagerSubscriptionMessage } from '../../constants';
import { PromotionalModalConfig } from '../../types';
import { RevHeroService } from '@app/src/app/services/RevHero';

@Component({
  selector: 'mg-mm-subscription-feature-modal',
  templateUrl: './mm-subscription-feature-modal.component.html',
  styleUrls: ['./mm-subscription-feature-modal.component.scss'],
})
export class MmSubscriptionFeatureModalComponent {
  // Constants
  public readonly MESSAGES = MingaManagerSubscriptionMessage;

  constructor(
    @Inject(MODAL_OVERLAY_DATA)
    public dialogData: PromotionalModalConfig,
    private _modalRef: ModalOverlayRef,
    private _revHeroService: RevHeroService,
  ) {}

  public openUpgradeRequestModal() {
    this._revHeroService.openUpgradeRequestModal();
    this._modalRef.close(ModalOverlayServiceCloseEventType.CLOSE);
  }
}
